import React from "react";
import { Link } from "react-router-dom";

export default function CampaignAiTrainingStep({
  trainerHref = "/ai-trainer",
  onTrainerClick,
}) {
  return (
    <div className="flex max-w-xl flex-col gap-5">
      <p className="text-[0.9375rem] leading-relaxed text-gray-700 dark:text-gray-300">
        Train your AI to refine sales messaging the way you write, or skip and
        come back anytime from the sidebar. It is recommended to train your AI
        on 1-2 contacts and review messaging before you upload mass contacts
        since it consumes AI credits.
      </p>
      <p className="text-[0.875rem] leading-relaxed text-gray-600 dark:text-gray-400">
        Use{" "}
        <Link
          to={trainerHref}
          className="font-semibold text-secondary underline decoration-secondary/30 underline-offset-2 transition-colors hover:text-secondary/90 hover:decoration-secondary"
          onClick={onTrainerClick}
        >
          AI Trainer
        </Link>
        <span className="text-gray-600 dark:text-gray-400">
          {" "}
          to train your campaign&apos;s content now, or tap{" "}
          <span className="font-medium text-gray-800 dark:text-gray-200">Finish</span> below to
          close and train later.
        </span>
      </p>
    </div>
  );
}
